export const normalizeEmail = (email: string) => email.trim().toLowerCase();
